<script setup>
import { inject } from 'vue'

const store = inject('store')

</script>

<template>
    <h1 class="display-4 text-uppercase text-grey mb-4">{{ store.state.hero.title }}
    </h1>
    <h3 class="fs-1 text-uppercase text-secondary mb-4">
        {{ store.state.hero.subtitle1 }}
        <span class="text-grey">{{ store.state.hero.subtitle2 }}</span>
    </h3>
    <p class="text-secondary">{{ store.state.hero.para }}</p>
</template>
